<div class="cart-page"><Cart :mini="true"></Cart></div>